import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { LiquidacaoLstComponent } from './liquidacao-lst/liquidacao-lst.component';
import { LiquidacaoShwComponent } from './liquidacao-shw/liquidacao-shw.component';

const routes: Routes = [
  {
    path: 'pesquisa/:pagina/:data1/:data2',
    component: LiquidacaoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'pesquisa/:pagina/:data1/:data2/:filtro',
    component: LiquidacaoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2',
    component: LiquidacaoShwComponent, canActivate: [AuthGuard]
  },
  {
    path: 'visualiza/:id/:pagina/:data1/:data2/:filtro',
    component: LiquidacaoShwComponent, canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LiquidacaoRoutingModule { }

